@if (editConfiguration) {
  <div class="container">
    <form [formGroup]="form" (ngSubmit)="onFormSubmit()">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>Edit layout</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="row">
            <div class="col-sm">
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input matInput class="form-control" formControlName="name" autocomplete="off"/>
                @if (hasError('name','empty')) {
                  <mat-error>Name cannot be empty</mat-error>
                }
                @if (hasError('name', 'nameExists')) {
                  <mat-error>Name already exists</mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Fonts
                  </mat-panel-title>
                  <mat-panel-description>
                    Specify custom fonts for this layout
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <mat-form-field [style.width.%]="100">
                  <mat-label>Font URLs (one per line)</mat-label>
                  <textarea matInput class="form-control" formControlName="fontUrls" rows="3"></textarea>
                  <mat-hint>Enter Google Fonts or other font URLs, one per line</mat-hint>
                </mat-form-field>
                <pub-font-upload [editConfiguration]="editConfiguration"
                [formControlName]="'uploadedFontIds'"></pub-font-upload>
                <div class="row mb-2">
                  <div class="col-sm-5">
                    <mat-form-field [style.width.%]="100">
                      <mat-label>Default Font Family</mat-label>
                      <input matInput class="form-control" formControlName="cssFontFamily"
                        placeholder="'Roboto', sans-serif"/>
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    CSS Variables
                  </mat-panel-title>
                  <mat-panel-description>
                    Override default CSS variables
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <pub-css-variables-editor [editConfiguration]="editConfiguration"
                [cssVariables]="editConfiguration.cssVariables"></pub-css-variables-editor>
              </mat-expansion-panel>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-sm-12">
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    CSS Rules
                  </mat-panel-title>
                  <mat-panel-description>
                    Specify custom CSS rules for this layout
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <mat-form-field [style.width.%]="100">
                  <mat-label>CSS</mat-label>
                  <textarea matInput class="form-control" formControlName="css" rows="6"></textarea>
                </mat-form-field>
              </mat-expansion-panel>
            </div>
          </div>
          <h6 class="mt-3">Components</h6>
          <mat-accordion multi>
            <pub-component-editors-list [configuration]="editConfiguration"></pub-component-editors-list>
          </mat-accordion>
        </mat-card-content>
        <mat-card-actions>
          <div class="row">
            <div class="col-sm buttons-panel">
              <button mat-raised-button color="primary" (click)="saveEditConfiguration()" [disabled]="!form.valid">Apply
              </button>
              <button mat-raised-button color="primary" (click)="saveEditConfiguration(true)" [disabled]="!form.valid">
                {{ isEditing() ? 'Update' : 'Create' }} &amp; Close
              </button>
              <button mat-raised-button (click)="cancelEdit()">Cancel</button>
            </div>
          </div>
        </mat-card-actions>
      </mat-card>
    </form>
  </div>
}
